import { activateMenuButton, deactivateMenuButton } from './header-bar';
import { closeAllMenus, disableBodyScroll, enableBodyScroll } from './utils';

const headerMenuClass = 'c-header-menu';
const headerMenuOpenClass = headerMenuClass + '--open';

const headerMenuJsClass = 'js-header-menu';
const accordionsDynamicJsClass = headerMenuJsClass + '-accordions-dynamic';
const accordionsStaticJsClass = headerMenuJsClass + '-accordions-static';
const entitiesJsClass = headerMenuJsClass + '-entities';
const iconLinksJsClass = headerMenuJsClass + '-icon-links';

const headerMenuElement = document.querySelector('.' + headerMenuJsClass) as HTMLElement;
const accordionsDynamicElement = document.querySelector('.' + accordionsDynamicJsClass) as HTMLElement;
const accordionsStaticElement = document.querySelector('.' + accordionsStaticJsClass) as HTMLElement;
const entitiesElement = document.querySelector('.' + entitiesJsClass) as HTMLElement;
const iconLinksElement = document.querySelector('.' + iconLinksJsClass) as HTMLElement;
let lastElement: HTMLAnchorElement;

const headerBarJsClass = 'js-header-bar';
const menuButtonJsClass = headerBarJsClass + '-menu-button';

const menuButtonElement = document.querySelector('.' + menuButtonJsClass) as HTMLElement;

if (headerMenuElement && menuButtonElement) {
    // We add a custom event listener to close the menu
    document.addEventListener('closeHeaderMenu', () => {
        closeHeaderMenu();
    });

    // We add click event listener on the menu button
    menuButtonElement.addEventListener('click', () => {
        // If the menu is open
        if (headerMenuElement.classList.contains(headerMenuOpenClass)) {
            // We close the menu
            closeHeaderMenu();
        } else {
            // We open the menu
            openHeaderMenu();
        }
    });

    // We add a keydown event listener on the menu
    headerMenuElement.addEventListener('keydown', (event) => {
        // If the menu is open and the escape key is pressed
        if (
            event.key === 'Escape'
            && !event.ctrlKey
            && !event.altKey
            && !event.metaKey
            && !event.shiftKey
            && headerMenuElement.classList.contains(headerMenuOpenClass)
        ) {
            // We close the menu
            closeHeaderMenu();
        }
    });

    // We get the last link element in the menu
    const linkElements = headerMenuElement.querySelectorAll('a');

    // If there are links in the menu
    if (linkElements.length > 0) {
        // We get the last link
        lastElement = linkElements[linkElements.length -1];

        // We add a keydown event listener on the last element
        lastElement.addEventListener('keydown', (event) => {
            // If the tab key is down while the last element is focused
            if (
                event.key === 'Tab'
                && !event.ctrlKey
                && !event.altKey
                && !event.metaKey
                && !event.shiftKey
            ) {
                // We stop the default behavior
                event.preventDefault();
                // We set the focus on the menu button
                menuButtonElement.focus();
                // We close the menu
                closeHeaderMenu();
            }
        });

        getFirstElements().forEach((element) => {
            // We add a keydown event listener on the first element(s)
            element.addEventListener('keydown', (event) => {
                // If the tab and shift keys are down while the first element is focused
                if (
                    event.key === 'Tab'
                    && !event.ctrlKey
                    && !event.altKey
                    && !event.metaKey
                    && event.shiftKey
                ) {
                    // We stop the default behavior
                    event.preventDefault();
                    // We set the focus on the menu button
                    menuButtonElement.focus();
                    // We close the menu
                    closeHeaderMenu();
                }
            });
        });
    }
}

export function openHeaderMenu (): void {
    if (!headerMenuElement || !menuButtonElement) {
        return;
    }

    // We close all open menus
    closeAllMenus();

    // We activate the button
    activateMenuButton();

    // If the menu is closed
    if (!headerMenuElement.classList.contains(headerMenuOpenClass)) {
        // Open menu
        headerMenuElement.classList.add(headerMenuOpenClass);
        // Disable body scroll
        disableBodyScroll();
        // We set the focus on the first element
        focusFirstElement();
    }
}

export function closeHeaderMenu (): void {
    if (!headerMenuElement || !menuButtonElement) {
        return;
    }

    // We deactivate the button
    deactivateMenuButton();

    // If the menu is open
    if (headerMenuElement.classList.contains(headerMenuOpenClass)) {
        // Close menu
        headerMenuElement.classList.remove(headerMenuOpenClass);
        // Enable body scroll
        enableBodyScroll();
        // We set focus on the menu button
        menuButtonElement.focus();
    }
}

function focusFirstElement (): void {
    getFirstElements().forEach((element) => {
        element.focus();
    });
}

function getFirstElements (): HTMLElement[] {
    if (accordionsDynamicElement && accordionsStaticElement) {
        // Accordions are the first section
        // Depending on screen size, the first interractable element will either be a button from an accoridon or a link
        return [accordionsDynamicElement.querySelector('button'), accordionsStaticElement.querySelector('a')];
    } else if (entitiesElement) {
        // Entities are the first section
        return [entitiesElement.querySelector('a')];
    } else if (iconLinksElement) {
        // Icon links are the first section
        return [iconLinksElement.querySelector('a')];
    } else {
        return [];
    }
}